import axios from 'axios'
import { normalizeError } from './utils'

const queueService = () => {
  const fetchQueueCounts = async (queueId, accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get(`/api/queue/${queueId}`, config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const fetchQueues = async (accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get('/api/queue', config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const triggerService = async (queueId, accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.post(`/api/trigger/${queueId}`, null, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const retryDLQMessages = async (queueId, accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.post(`/api/queue/${queueId}/retry`, null, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  const clearDLQ = async (queueId, accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      await axios.post(`/api/queue/${queueId}/purge-dlq`, null, config)
    } catch (error) {
      throw normalizeError(error)
    }
  }

  return {
    fetchQueueCounts,
    fetchQueues,
    triggerService,
    retryDLQMessages,
    clearDLQ,
  }
}

export default queueService()
